/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      IdentityNumbers: '$MHF_ModelNameVal_$MHF|IdentityNumbers',

};
